// import node_modules
import * as PropTypes from 'prop-types';
import * as React from 'react';

// import types
import type { MDXRemoteSerializeResult } from 'next-mdx-remote';
import {
  ReleaseNoteAppType,
  ReleaseNoteAppTypeEnum,
  ReleaseNoteCategory,
  ReleaseNoteCategoryEnum,
} from '../../types';

// import components
import ReleaseNote from '../elements/ReleaseNote';

// import styles
import styles from './ReleaseNotesList.module.css';

// define components
const ReleaseNotes: React.FunctionComponent<{
  releaseNotes: {
    app: ReleaseNoteAppType;
    category: ReleaseNoteCategory;
    content: MDXRemoteSerializeResult;
    ctaLink?: string | null;
    ctaText?: string | null;
    pubDate: string;
    slug: string;
    title: string;
    type: string;
  }[];
}> = ({ releaseNotes }) => (
  <div className={styles.list}>
    {releaseNotes.map((releaseNote) => (
      <ReleaseNote key={releaseNote.title} releaseNote={releaseNote} />
    ))}
  </div>
);

ReleaseNotes.propTypes = {
  releaseNotes: PropTypes.arrayOf(
    PropTypes.shape({
      app: PropTypes.oneOf(Object.values(ReleaseNoteAppTypeEnum)).isRequired,
      category: PropTypes.oneOf(Object.values(ReleaseNoteCategoryEnum)).isRequired,
      content: PropTypes.shape({ compiledSource: PropTypes.string.isRequired }).isRequired,
      ctaLink: PropTypes.string,
      ctaText: PropTypes.string,
      pubDate: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
};

ReleaseNotes.displayName = 'ReleaseNotes';

export default ReleaseNotes;
